import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import Logo from '../../components/Logo/Logo';
import GridRow from '../../components/GridRow/GridRow';
import Input from '../../components/Input/Input';
import i18n from '../../utils/i18n';
import Button from '../../components/Button/Button';
import NotificationInline, { NotificationTypeEnum } from '../../components/NotificationInline';
import { postLogin } from '../../utils/fetch/fetchLogin';
import s from './styles/login.module.scss';

const Login = () => {
    const { control, handleSubmit } = useForm();
    const [hasError, setError] = useState<boolean>(false);
    const [isLoading, setLoading] = useState<boolean>(false);

    const submit = handleSubmit(async (data) => {
        setLoading(true);
        setError(false);
        const response = await postLogin(data);
        if (!response) {
            setLoading(false);
            setError(true);
        }
    });

    return (
        <GridRow column gutter={8} className={s.root}>
            <Logo className={s.logo} />
            {hasError && <NotificationInline text={i18n.login.error} type={NotificationTypeEnum.ERROR} />}
            <Controller
                name={'username'}
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <Input
                        value={value}
                        onChange={onChange}
                        onSubmit={submit}
                        label={i18n.login.name}
                        error={!!error}
                    />
                )}
            />
            <Controller
                name={'password'}
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <Input
                        value={value}
                        type={'password'}
                        onChange={onChange}
                        onSubmit={submit}
                        label={i18n.login.password}
                        error={!!error}
                    />
                )}
            />
            <Button isLoading={isLoading} onClick={submit} label={i18n.login.enter} />
        </GridRow>
    );
};

export default Login;
